const BodyFooter = () => (
    <footer>
    </footer>
)

export default BodyFooter